
import { ICommonPensionInputs, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import * as moment from 'moment'

enum Local705FormOfPayment {
    fiftyPercentJointAndSurvivorWithPopup = 102,
    seventyFivePercentJointAndSurvivorWithPopup = 103,
    fullJointAndSurvivorWithPopup = 104,
    lifeOnlyWithDeathBenefit = 105,
    partialLumpSum = 106
  }

interface ILocal705PensionInputs extends ICommonPensionInputs {
    accruedBenefit: number
    beginPaymentsAge: moment.Duration
    benefitServiceYears: moment.Duration
    employerCode: string
    formOfPayment: Local705FormOfPayment | SimplePensionFormOfPayment
    futureWeeksPerYear: number,
    YRCHollandBenSvcTo2009: number,
    YRCVestSvcFrozenPd: number,
    employerContribution: number
}

export {
    ILocal705PensionInputs,
    Local705FormOfPayment
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local705/interfaces/index.ts